//common
import './common';

//components
import './blocks/slider-banner-main'
import './blocks/popup'

import RecipesCarousel from './blocks/slider-recipes'
import NewRecipesCarousel from './blocks/slider-new-recipes'


addEventListener('ajax:update-complete', () => {
    RecipesCarousel.init();
    NewRecipesCarousel.init()
})
